<template lang="pug">
  bulma-accordion
    bulma-accordion-item
      p.title.is-4.has-text-weight-normal(slot='title')
        | Autotanques
      i.material-icons(slot='icon') more_vert
      .high(slot='content')
        .columns.card-row
          CardAutotanque(v-for="auto in listAutotanques" :key="auto.SbiID" :autotanque="auto")
        .columns.card-row
          .column.is-4.is-offset-4
            span(v-html="convertData()")
</template>

<script>
  import CardAutotanque from '@/components/sca_Componentes/acceso/CardAutotanque.vue'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  export default {
    name: 'ListCardsAutotanques',
    components: { CardAutotanque, BulmaAccordion, BulmaAccordionItem },
    props: {
      listAutotanques: {
        type: Array,
        default: []
      },
    },
    methods: {
      convertData() {
        console.log('Convertir Data')
        let texto = ''
        let total = 0
        this.listAutotanques.forEach(pg => {
          let cap82 = 0
          let barriles = 0
          cap82 = Math.round(((parseInt(pg.capacidad) * 82)/90),2)
          barriles = cap82 / 158.9873
          total += Math.round((barriles / 11.83) * 100) / 100
        })
        texto = `<span class="tag is-dark">Masa Aprox. ${total} Ton.</span>`
        return texto
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/ListCardsAutotanques.vue